import { ReactNode, useEffect, useState } from 'react';
import classNames from 'classnames';
import Navbar from './Navbar';
import { useUserContext } from 'src/context/UserProvider';
import { useLocation } from 'react-router-dom';
import { UserRole } from 'types';
import Footer from './Footer';
import ScrollToTop from 'src/utils/ScrollToTop';
import { Helmet } from 'react-helmet';

type LayoutProps = {
	children: ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
	const { user, isJobseekerLoggedIn, isRecruiterLoggedIn, isMentorLoggedIn, isUserUniversityManagerLoggedIn } =
		useUserContext();
	const { pathname } = useLocation();
	const [shouldShowNavbarAndFooter, setShowNavbarAndFooter] = useState<boolean>(false);
	const [hideFooter, setHideFooter] = useState<boolean>(false);
	const shouldScroll = false;

	useEffect(() => {
		setShowNavbarAndFooter(
			!(
				!user ||
				// (isJobseekerLoggedIn && user?.flags?.showOnboardingVideo) ||
				pathname.includes('/interviews/live/') ||
				pathname.includes('/live-contest/') ||
				pathname.includes('explainers') ||
				pathname.includes('onboarding') ||
				pathname.includes('job-preview') ||
				pathname.includes('create-company') ||
				pathname.includes('edit-company') ||
				pathname.includes('create-position') ||
				pathname.includes('edit-position') ||
				pathname.includes('sessions/live') ||
				pathname.includes('placed-hiring-assessment') ||
				pathname.includes('offline-drive-attendance') ||
				pathname.includes('offline-drive-day-opportunities')
			),
		);
		setHideFooter(
			pathname.includes('linkedin-edit') ||
			pathname.includes('screening') ||
			pathname.includes('drive-form') ||
			pathname.includes('upcoming-drives') ||
			pathname.includes('placed-hiring-assessment') ||
			pathname.includes('offline-drive-attendance') ||
			pathname.includes('offline-drive-day-opportunities') ||
			pathname.includes('placement-drive-registration'),
		);
	}, [user, isJobseekerLoggedIn, pathname, isRecruiterLoggedIn, isUserUniversityManagerLoggedIn]);

	return (
		<div className={classNames('relative w-full', shouldScroll ? '!overflow-y-scroll' : '')}>
			{process.env.REACT_APP_NODE_ENV !== 'production' ? (
				<Helmet>
					<meta name="robots" content="noindex,nofollow" />
				</Helmet>
			) : null}

			<ScrollToTop />
			{shouldShowNavbarAndFooter ? <Navbar /> : null}
			<div
				className={`relative !min-h-screen flex flex-col overflow-x-clip ${user
						? `${shouldShowNavbarAndFooter ? 'pt-[70px] pb-[70px] md:pb-0' : ''} ${shouldShowNavbarAndFooter && user.role !== UserRole.RECRUITER ? 'sm:pb-[70px]' : ''
						} `
						: ''
					}`}
			>
				{children}
			</div>
			<div className="md:hidden block w-full">
				{shouldShowNavbarAndFooter && !isMentorLoggedIn && !hideFooter ? <Footer /> : null}
			</div>
		</div>
	);
};

export default Layout;
